<header class="flex header">
  <h2>
    {{ 'productionCardSelectModal.title' | translateWF: 'Pending Production Cards' }}
  </h2>
  <p-toast position="bottom-right" key="br" />
  <p-button icon="pi pi-times" (click)="onClose()" />
</header>
<section class="content">
  <app-production-cards-viewer
    [workOrder]="workOrder"
    [isForSelection]="true"
    [readonly]="true"
    [hasOverflow]="true"
    [showAssignRollButton]="false"
    [currentProductionCards]="filteredProductionCards"
    [productionCardsSelected]="productionCardsSelected"
    (productionCardSelected)="pushProductionCardSelected($event)"
    (productionCardUnselected)="removeProductionCardSelected($event)"
    [includeDeleted]="false"
  />
</section>
<footer>
  <p-button class="w-full" [label]="'Add' | translateWF: 'Add'" (click)="onClose()" />
</footer>

<loading-overlay [isLoading]="isLoading" [fullWidth]="true" />
